var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomotive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01186 27.5871H4.61305C3.87106 27.5871 3.15949 27.2925 2.63483 26.7677C2.11018 26.2431 1.81543 25.5314 1.81543 24.7895V19.1943C1.81543 18.4523 2.11018 17.7407 2.63483 17.2161C3.15949 16.6914 3.87106 16.3967 4.61305 16.3967H8.80948L10.9636 9.90618C11.1583 9.32713 11.5372 8.8277 12.0423 8.48418C12.5475 8.14066 13.1512 7.97197 13.7613 8.0038H24.9797C25.5898 7.97197 26.1935 8.14066 26.6987 8.48418C27.2038 8.8277 27.5827 9.32713 27.7773 9.90618L29.7916 16.3967H35.3869C36.1288 16.3967 36.8405 16.6914 37.3651 17.2161C37.8896 17.7407 38.1845 18.4523 38.1845 19.1943V24.7895C38.1845 25.5314 37.8896 26.2431 37.3651 26.7677C36.8405 27.2925 36.1288 27.5871 35.3869 27.5871H33.988",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7886 31.7836C27.4695 31.7836 25.5894 29.9033 25.5894 27.5841C25.5894 25.2649 27.4695 23.3848 29.7886 23.3848C32.1081 23.3848 33.9881 25.2649 33.9881 27.5841C33.9881 29.9033 32.1081 31.7836 29.7886 31.7836Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2053 31.7836C7.886 31.7836 6.00586 29.9033 6.00586 27.5841C6.00586 25.2649 7.886 23.3848 10.2053 23.3848C12.5245 23.3848 14.4046 25.2649 14.4046 27.5841C14.4046 29.9033 12.5245 31.7836 10.2053 31.7836Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5894 27.5872H14.4048",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomotive);
export default __webpack_public_path__ + "static/media/Automotive.52ffca4eb3d3ccd3b6d55bc991ffe605.svg";
export { ForwardRef as ReactComponent };